// Angular
import { Component, ViewChild, OnInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

// Grid
import { CerAppFileViewerTabComponent, TabSelectedApplyData } from 'src/cer-app/cer-app-file-viewer-tab/cer-app-file-viewer-tab.component';

// Api
import { ChatDto, LinkedAttachmentDto, VoucherMessageViewDetailsVm } from 'src/app/api';

// App
import { VoucherDataService } from '../voucher-data.service';
import { VoucherMessageViewService } from './vouchermessage-view.service';
import { VoucherAttachmentService } from '../voucher-attachment.service';
import { CerFormComponent, CerFromInfoAction } from '@form/cer-form.component';
import { UiActionTypeEnum, UiCommandEvent } from '@ui/cer-ui-types';
import { CerFormPanesSettings } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormPaneComponent } from '@form/cer-form-panes/cer-form-pane/cer-form-pane.component';

@Component({
  selector: 'vouchermessage-list',
  templateUrl: './vouchermessage-list.component.html',
  styleUrls: ['../voucher.css'],
  providers: [VoucherMessageViewService, VoucherDataService, VoucherAttachmentService]
})

export class VoucherMessageListComponent implements OnInit, OnDestroy {

  // File Viewer Tab State
  protected attachments: LinkedAttachmentDto[];
  protected chats: ChatDto[];
  protected attachmentToken: string;
  protected attachmentRefRowId: number;
  protected attachmentSaveUrl: string;
  protected attachmentRemoveUrl: string;

  protected infoAction: CerFromInfoAction = 'select';

  protected panes: CerFormPanesSettings = null;
  
  constructor(
    private route: ActivatedRoute,
    private messageViewService: VoucherMessageViewService,
    private voucherDataService: VoucherDataService,
    protected attachmentService: VoucherAttachmentService) {

    this.voucherDataService.init(this.route);
  }
  
  public ngOnInit(): void {
    this.manage(this.messageViewService.paneSetupComplete$.subscribe(panes => this.panesInit(panes)));
    this.messageViewService.init();
    this.manage(this.voucherDataService.detailsVm$.subscribe(vm => this.onDetailVm(vm)));
  }

  private panesInit(panes: CerFormPanesSettings) {
    this.panes = panes;
   // this.cd.detectChanges();
  }

  private subscriptionManager: Subscription = new Subscription();
  private manage(s: Subscription) {
    this.subscriptionManager.add(s);
  }

  public ngOnDestroy() {
    this.subscriptionManager.unsubscribe();
  }

  // Form
  private form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && !this.form) {
      this.form = content;
      this.initFormAndFileViewerTab();
    }
  }

  // Panes
  @ViewChildren(CerFormPaneComponent) set setPaneComponents(paneComponents: QueryList<CerFormPaneComponent>) {
    if (paneComponents?.length > 0 && this.form != null) {
      this.form.initContext(paneComponents);
    }
  }

  // FileViewerTab
  private tabAttachments: CerAppFileViewerTabComponent;
  @ViewChild('tabAttachments', { static: false }) set tabContent(content: CerAppFileViewerTabComponent) {
    if (content && !this.tabAttachments) {
      this.tabAttachments = content;
      this.initFormAndFileViewerTab();
    }
  }

  private initFormAndFileViewerTab() {
    if (this.form != null) {
      if (this.tabAttachments != null) {
        this.attachmentService.init(this.form, this.tabAttachments);
      }
      this.messageViewService.initForm(this.form);
    }
  }

  // Grid
  /*
  private grid: CerGridComponent;
  @ViewChild('grid', { static: false }) set gridContent(content: CerGridComponent) {
    if (content && this.grid != content) {
      this.grid = content;
      this.messageViewService.initGrid(this.grid);
      this.voucherDataService.initGrid(this.grid);
      this.grid.init();
      this.manage(this.grid.commmand.subscribe(cmd => this.onGridCommand(cmd)));
    }
  }
  */

  protected onCommand(cmd: UiCommandEvent) {
    if (cmd.actionType == UiActionTypeEnum.ChatClicked) {
      if (this.tabAttachments) {
        this.tabAttachments.tabSelectedIndexInitial = this.attachments.length ?? 0;
      }
    }
  }

  // File viewer
  protected attachmentIdxDefault: number = null;
  private onDetailVm(vm: VoucherMessageViewDetailsVm) {
    this.chats = vm?.chatDtoList ?? [];
    this.attachmentToken = vm?.voucherMessageViewDto?.messageToken;
    this.attachmentRefRowId = vm?.voucherMessageViewDto?.id;
    this.attachments = vm?.voucherMessageAttachmentDtoList ?? [];
    this.attachmentIdxDefault = this.attachmentService.getAttachmentSelectextIdxDefault(this.attachments) ?? 0;
    this.attachmentSaveUrl = vm?.attachmentsSaveUrl;
    this.attachmentRemoveUrl = vm?.attachmentsRemoveUrl;
  }

  protected onAttachmentTabSelectedIndexChanged(index: number) {
    this.messageViewService.voucherDetailsDialogAttachmentIdxDefault = index;
  }

  protected onAttachmentCheckBoxApply(apply: TabSelectedApplyData) {
    var id: number = this.tabAttachments.refRowId;
    if (id) {
      var callback = () => {
        this.voucherDataService.detailsVmMap.delete(id); // force reload
        this.messageViewService.research();
      }
      this.attachmentService.messageAttachmentsApply(apply, callback);
    }
  }
}
